import KeyFlowVO from 'commons/vo/KeyFlowVO';

type QuarterVOProps = {
  ID: number;
  CATEGORY_ID: number;
  TYPE: string;
  REF: string;
  SCRIPT: string;
  OWNER: number;
  VIDEO_ID: number;
  IN_POINT: number;
  OUT_POINT: number;
  THUMBNAIL_PATH: string;
  THUMBNAIL_FRAME: number;
  DOWNLOAD_COUNT: number;
  RATING: number;
  DATE_OF_CREATED: string;
  DATE_OF_MODIFIED: string;
};

class QuarterVO extends KeyFlowVO {
  id: number;
  categoryId: number;
  type: string;
  ref: string;
  script: string;
  owner: number;
  videoId: number;
  inPoint: number;
  outPoint: number;
  thumbnailPath: string;
  thumbnailFrame: number;
  downloadCount: number;
  rating: number;
  dateOfCreated: string;
  dateOfModified: string;

  constructor(data: QuarterVOProps) {
    super(data);
    this.id = data.ID;
    this.categoryId = data.CATEGORY_ID;
    this.type = data.TYPE;
    this.ref = data.REF;
    this.script = data.SCRIPT;
    this.owner = data.OWNER;
    this.videoId = data.VIDEO_ID;
    this.inPoint = data.IN_POINT;
    this.outPoint = data.OUT_POINT;
    this.thumbnailPath = data.THUMBNAIL_PATH;
    this.thumbnailFrame = data.THUMBNAIL_FRAME;
    this.downloadCount = data.DOWNLOAD_COUNT;
    this.rating = data.RATING;
    this.dateOfCreated = data.DATE_OF_CREATED;
    this.dateOfModified = data.DATE_OF_MODIFIED;
  }
}

export default QuarterVO;
